import React, { Component } from "react";
import VideoModalPlayer from "./VideoModalPlayer";
import PropTypes from "prop-types";
import axios from "axios";
import getContent from "pp-react-l10n";
import getHTMLElement from "../lib/setHtmlHelper";
import { getRandomInt, getColorIdx } from '../lib/brcClientHelper';
import formatDate from "../lib/dateHelper";

class Maintilescontainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      page_size: 12,
      tilesBundle: this.props.tilesInfo,
      isMounted: false
    };
    this.handleLoadMore = this.handleLoadMore.bind(this);
  }

  componentDidMount() {
    this.setState({
      isMounted: true
    });
  }

  handleLoadMore() {
    const self = this;
    axios
      .get("loadMore", {
        params: {
          page: this.state.page,
          page_size: this.state.page_size,
          pageType: "articles",
        },
      })
      .then(function (response) {
        if (response.data.results) {
          self.setState({
            tilesBundle: JSON.parse(response.data.results),
            page_size: self.state.page_size + 3,
          });
        } else {
          self.setState({
            tilesBundle: self.state.tilesBundle,
          });
        }
      })
      .catch(function (error) {
        self.setState({
          tilesBundle: self.state.tilesBundle,
        });
      });
  }

  render() {
    const getTilesContent = getContent("staticContent");
    const colorsd = this.props.colors;
    const topicsHash = this.props.topicsHash;
    const country = this.props.country.toLowerCase();
    // const totalArticles = this.props.totalArticles;
    const locale = this.props.locale.split("_")[0];
    const fontChange =
      country === "vn" && this.props.locale === "vi_VN" ? "vnFont" : country === 'jp' && this.props.locale === 'ja_JP' ? 'jpFont' : "";
    return (
      <div id="tiles-container" className="tilesContainer">
        <div className="Maintilescontainer">
          <h2 className={`vx_text-4 tilesheading ${fontChange}`}>
            {getTilesContent("brc.tilesHeader")}
          </h2>
          <ul className="tiles_list">
            {this.state.tilesBundle.map((tile, index) => {
              const updatedDate = formatDate(tile.updated_time, country, locale);
              const listItemId = `tile-list-item-${index}`;
              const bgColor = this.state.isMounted ? colorsd[getRandomInt(0, 6)] : getColorIdx(index, colorsd.length);
              return (
                <li
                  id={listItemId}
                  className="tile_elements tile_property"
                  style={
                    tile.sm_bg
                      ? {
                        backgroundImage: `url(${tile.sm_bg})`,
                        backgroundColor: bgColor,
                      }
                      : { backgroundColor: bgColor }
                  }
                  key={index}
                >
                  <a
                    data-pa-click={"tileClick|" + tile.url_slug}
                    className="reqPath"
                    href={
                      this.props.attachUrl.length > 0
                        ? `/${country}/brc/article/${tile.url_slug}?${this.props.attachUrl}`
                        : `/${country}/brc/article/${tile.url_slug}`
                    }
                    key={tile.url_slug + index}
                  >
                    <div
                      className="vx_panel-header tile_header"
                      key={tile.category + index}
                    >
                      {(topicsHash[tile.category] || tile.category) &&
                        (
                          topicsHash[tile.category] || tile.category
                        ).toUpperCase()}{" "}
                    </div>
                    <div
                      className={
                        `tileClick|${tile.url_slug}| vx_panel-text tile_sd`
                      }
                      key={tile.heading + index}
                    >
                      {getHTMLElement(tile.heading, { useHTML: true })}{" "}
                    </div>
                  </a>
                  <VideoModalPlayer
                    slugId={tile.url_slug}
                    source={tile.content}
                    id={listItemId}
                  />
                  <p
                    className="vx_text-body tile_description"
                    key={tile.desc + index}
                  >
                    {" "}
                    {getHTMLElement(tile.desc, { useHTML: true })}{" "}
                  </p>
                  <div
                    className="vx_text-body_secondary tile_date"
                    key={updatedDate + index}
                  >
                    {updatedDate === "Invalid date" ? "" : updatedDate}
                  </div>
                </li>
              );
            })}
          </ul>
          {this.state.tilesBundle.length < this.props.totalArticles ? (
            <div className="tile-btn">
              <button
                type="submit"
                data-pa-click={"brcHomeLoadMoreClick|" + this.state.page_size}
                onClick={this.handleLoadMore}
                className="load-more-btn"
              >
                {getTilesContent("brc.tilesButton")}
              </button>
            </div>
          ) : (
            <span />
          )}
        </div>
      </div>
    );
  }
}

Maintilescontainer.propTypes = {
  tilesInfo: PropTypes.array,
  colors: PropTypes.array,
  totalArticles: PropTypes.number,
  topicsHash: PropTypes.object,
  country: PropTypes.string,
};

export default Maintilescontainer;
